/**
 * 統計情報サービス
 */

import { fetchWithAuth, API_BASE_URL } from '@/lib/api';

export interface DashboardStats {
  total_articles: number
  published_articles: number
  this_month_generated: number
  by_type: Record<string, number>
  by_status: Record<string, number>
  recent_articles: Array<{
    id: number
    title: string
    created_at: string
    status: string
  }>
}

export interface StatsResponse {
  status: string
  data: DashboardStats
}

class StatsService {
  private baseUrl = `${API_BASE_URL}/stats`

  /**
   * ダッシュボード統計情報を取得
   */
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await fetchWithAuth(this.baseUrl)
    
    if (!response.ok) {
      throw new Error(`Failed to fetch dashboard stats: ${response.status}`)
    }
    
    const result: StatsResponse = await response.json()
    return result.data
  }
}

export const statsService = new StatsService()